import { useInView } from 'react-intersection-observer';

import type { AnalyticsListOptions } from '../../../../analytics/analyticsHandler';
import type { ApiProduct } from '../../../../models/ecommerce/product/ApiProduct';

import { storeSelectors } from '../../selectors/storeSelectors';
import { ga4ItemsTracking } from '../../tracking/ga4/items';
import { useAppSelector } from '../useThunkDispatch';
import { useIsUserAMember } from '../useUserProfile';

export const useBuyableItemGATracking = (
    product: ApiProduct,
    variantId: string | undefined,
    analyticsOptions: AnalyticsListOptions | null,
) => {
    const currentProductionUnit = useAppSelector(storeSelectors.currentProductionUnit);
    const isUserMember = useIsUserAMember();

    const [ref] = useInView({
        threshold: 0.5,
        triggerOnce: true,
        onChange: (inView) => {
            if (inView && analyticsOptions) {
                ga4ItemsTracking.viewItemList(product, analyticsOptions, isUserMember);
            }
        },
    });

    /** From GA team: send GA select_item event ONLY when navigating to PDP */
    const handleGaProductClick = () => {
        if (analyticsOptions) {
            ga4ItemsTracking.selectItem(
                product.identifier,
                variantId,
                currentProductionUnit,
                isUserMember,
                analyticsOptions?.position,
                analyticsOptions,
            );
        }
    };

    return { ref, handleGaProductClick };
};
